import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import {
    deliverySetuplist ,createDeliverySetup , updateDeliverySetup , deleteDeliverySetup , deliverySetuplistbyID} from '../../services/delivery'


@Module({
    namespaced: true,
})


export default class Item extends VuexModule {

    // state 
    deliveryList = [];
    

    @Action
    public async createdeliverySetup(payload) {
        try {
            const data = await createDeliverySetup(payload);
            return data;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async updateDeliverySetup(payload) {
        try {
            const data = await updateDeliverySetup(payload.id, payload.data);
            return data
        } catch (error) {
            throw error

        }
    }
    @Action
    public async fetchdeliverysList() {
        try {
            const data = await deliverySetuplist();
            this.context.commit('setdeliveryList', data.response);
            return data
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchdeliverys(payload) {
        try {
            const data = await deliverySetuplistbyID(payload);
            this.context.commit('setdeliveryList', data.response);
            return data
        } catch (error) {
            throw error
        }
    }
    @Action
    public async deleteDeliverySetup(payload) {
        try {
            const data = await deleteDeliverySetup(payload);
            return data
        } catch (error) {
            throw error
        }
    }

    // mutations 

    @Mutation
    public setdeliveryList(data: any) {
        this.deliveryList = data;
    }
    
    
    
    // getters
    get GetDeliveryList() {
        return this.deliveryList;
    }

}

